import * as requestFromServer from "./professionalsCrud";
import { professionalsSlice, callTypes } from "./professionalsSlice";
import * as auth from "../../../Auth/_redux/authRedux";

const { actions } = professionalsSlice;

export const fetchProfessionals = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findProfessionals(queryParams)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { totalCount, entities } = response.data;
      dispatch(actions.professionalsFetched({ totalCount, entities }));
    })
    .catch(error => {
      error.clientMessage = "Can't find Professionals";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchProfessional = id => dispatch => {
  if (!id) {
    return dispatch(actions.professionalFetched({ professionalForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getProfessionalById(id)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const professional = response.data.professional;
      dispatch(actions.professionalFetched({ professionalForEdit: professional }));
    })
    .catch(error => {
      error.clientMessage = "Can't find professional";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteProfessional = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteProfessional(id)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.professionalDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete professional";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createProfessional = professionalForCreation => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createProfessional(professionalForCreation)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { professional } = response.data;
      dispatch(actions.professionalCreated({ professional }));
    })
    .catch(error => {
      error.clientMessage = "Can't create law Material";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProfessional = professionalForUpdate => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProfessional(professionalForUpdate)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { professional } = response.data;
      dispatch(actions.professionalUpdated({ professional }));
    })
    .catch(error => {
      error.clientMessage = "Can't update professional";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProfessionalsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForProfessionals(ids, status)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.professionalsStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update professionals status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteProfessionals = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteProfessionals(ids)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.professionalsDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete Professionals";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

//check phone
export const checkPhone = phone => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .checkPhone(phone)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.phoneChecked({ phone }));
    })
    .catch(error => {
      error.clientMessage = "Can't check phone";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
